import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditSegments from "pages/secure/facility/reservation/EditSegments";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    uiStore: { ...state.uiStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditSegments);
